export default __webpack_public_path__ + "static/media/IMG_036.eb89f88a.jpg";